//Clean inline styles off of all description elements and remove old conversion elements
var tabs = document.querySelector('.tabs-content')
if(tabs){
  tabs.querySelectorAll('*').forEach(el => {
    el.removeAttribute('style')
    el.removeAttribute('height')
    el.removeAttribute('width')
    el.removeAttribute('data-mce-style')
  });
}
removeIfExists('#centZ');
removeIfExists('#inchZ');
//Extract LI info to vars
var descAppends = document.querySelectorAll(".desc-append");
if(tabs){
  var prodDesc = document.getElementsByClassName("tabs-content")[0].children[0].innerHTML;
  var sizingInfo = document.getElementsByClassName("tabs-content")[0].children[1];
  var sizingInfoTable = sizingInfo.querySelector('table');
  sizingInfo.querySelectorAll('p').forEach(p =>{   
    if(p.innerText == 'For details about how we measure our garments visit the measuring guide.'){
      p.remove();
    }   
  })
} else{
  var prodDesc = document.getElementsByClassName("product-desc")[0].innerHTML;
  var sizingInfo = null;
  var sizingInfoTable = null;
}


if(sizingInfoTable != null){
  sizingInfoTable.classList.add('table','table-hover');
  //Make new conversion element
  if((sizingInfoTable.innerHTML.match(/"/g) || []).length > 8){
      var switchHTML = '<label class="switch"><input type="checkbox" id="togBtn"><div class="slider round"><span class="on">CM</span><span class="off">INCH</span></div></label><p>For details about how we measure our garments visit the <a href="/pages/measuring-guide">measuring guide.</a></p>'
      sizingInfoTable.insertAdjacentHTML('afterend', switchHTML)

  }
}

if(!tabs){
  sizingInfo = document.createElement('div')
  sizingInfo.innerHTML = '<p>For details about how we measure our garments visit the <a href="/pages/measuring-guide">measuring guide.</a></p>'
}

var sizingInfo = sizingInfo.innerHTML;
var brandInfo = document.querySelector("#collection-desc");

//Remove list elements
if(document.getElementsByClassName("tabs")[0]){
  document.getElementsByClassName("tabs")[0].remove();
}
if(document.getElementsByClassName("tabs-content")[0]){
  document.getElementsByClassName("tabs-content")[0].remove();
}

//Recreate info in HTML elements
var descDiv = document.querySelector(".product-desc");
descDiv.innerHTML = prodDesc;
for(dom of descAppends){
  descDiv.append(dom);
}
descDiv.classList.remove('loading');
document.querySelectorAll('h1').forEach(h1 => {
  if(h1.innerHTML == "Sizing &amp; Measurements"){
    h1.nextElementSibling.innerHTML = sizingInfo;
  } else if (h1.innerHTML == "Designer Information"){
    h1.nextElementSibling.innerHTML = brandInfo.innerHTML;
    brandInfo.remove();
  }
});
var tableData = new Array();
if(document.querySelector("#togBtn")){
  var baseTable = document.querySelector('tbody');
  var rowLength = baseTable.rows.length;
  for(var i = 1; i < rowLength; i++){
    //console.log(i);
    for(var j = 1; j < baseTable.rows[i].cells.length; j++){
      tableData.push(baseTable.rows[i].cells[j].innerHTML);
    }
  }
  var checkbox = document.querySelectorAll("#togBtn");
  checkbox.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        convertCm();
      } else {
        convertIn();
      }
    });
  })
}


function convertCm(){
    var sizingTables = document.querySelectorAll('tbody');
    sizingTables.forEach(sTable =>{
        sTable.parentElement.parentElement.querySelector('input').checked = true;
        var rowLength = sTable.rows.length;
        var tempNum;
        var convertNum;
        for(var i = 1; i < rowLength; i++){
            for(var j = 1; j < sTable.rows[i].cells.length; j++){
              tempNum = parseFloat(sTable.rows[i].cells[j].innerHTML)*2.54;
              convertNum = (Math.round(tempNum * 2) / 2).toFixed(1);
              if(convertNum % 1 == 0){
                sTable.rows[i].cells[j].innerHTML = parseFloat(convertNum).toFixed(0) + 'cm';
              } else {
                sTable.rows[i].cells[j].innerHTML = convertNum + 'cm';
              }
            }
        }
    })
}

function convertIn(){
      var sizingTables = document.querySelectorAll('tbody');
      sizingTables.forEach(sTable =>{
          sTable.parentElement.parentElement.querySelector('input').checked = false;
          var rowLength = sTable.rows.length;
          var counter = 0;
          for(var i = 1; i < rowLength; i++){
            for(var j = 1; j < sTable.rows[i].cells.length; j++){
              sTable.rows[i].cells[j].innerHTML = tableData[counter];
              counter++;
            }
          }
      });
}


function removeIfExists (selector) {
  var x = document.querySelector(selector)
  if (x) x.remove()
}

function  addWishlistNotification(type){
  if(window.customer){
    var email = `${customer}`; 
    var variantid = document.querySelector('input[name="id"]').value;
    var variantname = document.querySelector('#selected-option').innerHTML;
    var productid = document.querySelector('input[name="product-id"]').value;
    var productname = document.querySelector('.main-product__title').innerHTML;   
    productname = productname.replace(/&#39;/g, "\'");
    productname = productname.replace(/&quot;/g, "\"");
    var producturl = document.querySelector('meta[property="og:url"]').content;
    var photourl = document.querySelector('#ProductImg-0').src;
    var vendor = document.querySelector('.product-vendor-link').title
    vendor = vendor.replace(/&#39;/g, "\'");
    vendor = vendor.replace(/&quot;/g, "\"");
    var price = window.curprice.toString();
    price = price.substr(0, (price.length -2));
    price += '.00'
    var compareprice = '';
    if( window.saleprice > 0 ){
      compareprice = window.saleprice.toString();
      compareprice = compareprice.substr(0, (compareprice.length -2));
      compareprice += '.00'
    }
  
    var itemData = {
        'entrytype' : type,
        'customer': email,
        'variantid': variantid,
        'variantname': variantname,
        'productid' : productid,
        'productname' : productname,
        'producturl' : producturl,
        'photourl' : photourl,
        'vendor' : vendor,
        'price': price,
        'compareprice': compareprice,
        'customerToken': window.customerToken
    }
    let options = {
        method: 'POST',      
        headers: {
          'X-Shopify-Topic': 'wishlist/addNotification',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(itemData)
      };
      fetch('https://shielded-stream-33669.herokuapp.com/', options)
      .then(response => {
        if(response.status == 200){
          const svgs = { circle: { path: "M256,0C114.84,0,0,114.842,0,256s114.84,256,256,256s256-114.842,256-256S397.16,0,256,0z M256,462.452 c-113.837,0-206.452-92.614-206.452-206.452S142.163,49.548,256,49.548S462.452,142.163,462.452,256S369.837,462.452,256,462.452z ", pluspoints: "280.774,231.226 280.774,140.387 231.226,140.387 231.226,231.226 140.387,231.226 140.387,280.774 231.226,280.774 231.226,371.613 280.774,371.613 280.774,280.774 371.613,280.774 371.613,231.226 ", checkpoints: "345.838,164.16 222.968,287.029 157.904,221.967 122.87,257.001 222.968,357.1 380.872,199.194"},
                   mail: { path: "M0,62.061v387.879h512V62.061H0z M432.542,108.606L256,285.148L79.458,108.606H432.542z M465.455,403.394H46.545V141.518 L256,350.973l209.455-209.455V403.394z", points: "" } }
          var wishlistButton = document.querySelector("button[name='wishlistButton']");
          wishlistButton.classList.add('disabledB')
          wishlistButton.querySelector(".button__text").innerHTML = "On Your Wishlist";
          wishlistButton.querySelector("polygon").setAttribute('points', svgs.circle.checkpoints);
          wishlistButton.querySelector("path").setAttribute('d', svgs.circle.path);
          wishlistButton.removeAttribute('onClick')
          var stock = (type == 'restock') ? false : true;
          window.variantCheck[variantid] = {added: true, stock: stock};
        } else {
          throw error(response.status)
        }
      }).catch(error => {
          console.error(error);
      }); 
  }
}